import React, { useState, useEffect } from 'react';
import './MainHeader.css';
import SearchInput from '../Home/SearchInput';
import { Avatar, Button } from '@mui/material';
import {
  HomeWork, DirectionsCar, TwoWheeler, Build, Computer,
  CleanHands, Star, LocalOffer, Apartment, House, CarRental, SupportAgent,
  Emergency, Construction
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

function MainHeader() {
  const [location, setLocation] = useState('Loading location...');
  const [error, setError] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [categories, setCategories] = useState([]);
    const [input, setInput] = useState('');
    const [showSuggestions, setShowSuggestions] = useState(false);
  const navigate = useNavigate();

  // ✅ Get user from localStorage
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });


  const handleSearch = (e) => {
    e.preventDefault();
    if (input.trim()) {
      navigate(`/dealers?search=${encodeURIComponent(input)}`);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setInput(suggestion.name);
    setShowSuggestions(false);

    if (suggestion.type === 'main-category') {
      const formatted = formatCategory(suggestion.name);
      navigate(`/categories/${formatted}`);
    } else {
      navigate(`/dealers?category=${encodeURIComponent(suggestion.parentCategory)}&service=${encodeURIComponent(suggestion.parentService)}&subservice=${encodeURIComponent(suggestion.name)}`);
    }
  };
  const formatCategory = (name) => name.toLowerCase().replace(/\s+/g, '');

  const filteredSuggestions = input
    ? suggestions.filter(s => s.name.toLowerCase().includes(input.toLowerCase()))
    : suggestions.slice(0, 5);
    const totalSlides = Math.ceil(categories.length / 8); // since you show 8 per slide


  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          fetchLocationName(position.coords.latitude, position.coords.longitude);
        },
        (err) => {
          setError('Unable to retrieve location');
          console.error('Geolocation error:', err);
          setLocation('Location unavailable');
        }
      );
    } else {
      setError('Geolocation not supported');
      setLocation('Location unavailable');
    }
  }, []);

  useEffect(() => {
    fetch('https://anyworq.com/api/services')
      .then(res => res.json())
      .then(data => {
        const categoriesObj = data[0]?.categories?.[0] || {};
        const iconMap = {
          '<HomeWork />': <HomeWork />,
          '<DirectionsCar />': <DirectionsCar />,
          '<TwoWheeler />': <TwoWheeler />,
          '<Build />': <Build />,
          '<Computer />': <Computer />,
          '<CleanHands />': <CleanHands />,
          '<Star />': <Star />,
          '<LocalOffer />': <LocalOffer />,
          '<Apartment />': <Apartment />,
          '<House />': <House />,
          '<CarRental />': <CarRental />,
          '<SupportAgent />': <SupportAgent />,
          '<Emergency />': <Emergency />,
          '<Construction />': <Construction />
        };

        const parsedCategories = Object.keys(categoriesObj).map(name => ({
          name,
          ...categoriesObj[name],
          services: categoriesObj[name].services || [],
          icon: iconMap[categoriesObj[name].icon] || <LocalOffer />
        }));

        setCategories(parsedCategories);
      })
      .catch(err => console.error('Failed to fetch services:', err));
  }, []);

  useEffect(() => {
    const allSuggestions = categories.flatMap(cat => {
      const mainCat = {
        name: cat.name,
        type: 'main-category',
        icon: cat.icon,
        color: cat.color
      };

      const subCategories = cat.services.flatMap(service =>
        service.subServices.map(sub => ({
          name: sub.name,
          type: 'sub-category',
          parentCategory: cat.name,
          parentService: service.name
        }))
      );

      return [mainCat, ...subCategories];
    });

    setSuggestions(allSuggestions);
  }, [categories]);

  const fetchLocationName = async (lat, lng) => {
    try {
      const response = await fetch(
        `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lng}&localityLanguage=en`
      );
      const data = await response.json();
      setLocation(data.city || data.locality || 'Your location');
    } catch (err) {
      console.error('Reverse geocoding error:', err);
      setLocation('Your location');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
    window.location.href = '/categories/realestate';
  };

  return (
    <header className="MainHeader">
      <div className="MainHeader__links">
        <div className="search__logo">
  <a href='/'>
    <img 
      src="/logo.png" 
      alt="anyworq logo" 
      className='head-logo'
      loading="lazy" 
    />
  </a>
  <span className={error ? 'location-error' : 'location'}>
    <svg xmlns="http://www.w3.org/2000/svg" 
      width="16" 
      height="16"
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor"
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
      <circle cx="12" cy="10" r="3"></circle>
    </svg>
    {location}
  </span>
</div>


        <div className="MainHeader__links_left">
          <form className="search__form" onSubmit={handleSearch}>
          <div className="search__input-container">
            <div className="search__input">
              <input
                type="text"
                placeholder="Service Categories"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onFocus={() => setShowSuggestions(true)}
                onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
              />
              <button type="submit">Search</button>
            </div>

            {showSuggestions && filteredSuggestions.length > 0 && (
              <div className="suggestions-dropdown">
                {filteredSuggestions.map((suggestion, index) => (
                  <div
                    key={index}
                    className="suggestion-item"
                    onClick={() => handleSuggestionClick(suggestion)}
                  >
                    {suggestion.type === 'main-category' && (
                      <span
                        className="suggestion-icon"
                        style={{ color: suggestion.color }}
                      >
                        {suggestion.icon}
                      </span>
                    )}
                    <span className="suggestion-text">
                      {suggestion.name}
                      {suggestion.type === 'sub-category' && (
                        <span className="suggestion-category">
                          {suggestion.parentCategory} → {suggestion.parentService}
                        </span>
                      )}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </form>
          {/* <SearchInput placeholder="Service Categories" suggestions={suggestions} /> */}
        </div>

        <div className="MainHeader__links_right">
          {user ? (
            <div className="user-display" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Avatar>{user?.name?.charAt(0)}</Avatar>
              <span>{user?.name}</span>
              <Button variant="outlined" color="error" size="small" onClick={handleLogout}>
                Logout
              </Button>
            </div>
          ) : (
            <>
              {/* <Button variant="outlined" size="small" href="/login">Login</Button> */}
              <Button variant="contained" size="small" href="/user">Request Demo</Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export default MainHeader;
